import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useApolloClient } from '@apollo/client';
import type { RenderRuntimeDataServices } from '../../elements/types';
import { createRuntimeDataServices } from './createRuntimeDataServices';
import { invalidateBindingCatalog } from './bindingCatalog';

export function useRuntimeDataServices(): RenderRuntimeDataServices {
    const apolloClient = useApolloClient();
    const { i18n } = useTranslation();
    const { language } = i18n;

    return useMemo(() => {
        // Language change is the explicit trigger for rebuilding translated metadata.
        void language;
        invalidateBindingCatalog();
        return createRuntimeDataServices(apolloClient);
    }, [apolloClient, language]);
}
